import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=3872703c&"
import script from "./BookDetails.vue?vue&type=script&lang=ts&"
export * from "./BookDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports